module.exports = __webpack_public_path__ + "static/media/logo-banco-frente.b8c458b9.png";